<template>
  <CDropdown 
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item mx-2"
    add-menu-classes="pt-0 pb-0 shadow-sm border-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell" size="xl"/>
        <CBadge v-if="items.length > 0" shape="pill" color="danger" class="notification-badge">
          {{ items.length }}
        </CBadge>
      </CHeaderNavLink>
    </template>
    
    <CDropdownHeader tag="div" class="text-center py-2" color="light">
      <strong>Alertas de Stock ({{ items.length }})</strong>
    </CDropdownHeader>
    
    <div v-if="items.length > 0" class="notification-scroll">
      <CDropdownItem
        v-for="item in items"
        :key="item.id"
        class="border-bottom py-2 notification-item"
      >
        <div class="d-flex align-items-start w-100">
          <CIcon 
            :name="item.total_product_stock <= 0 ? 'cil-ban' : 'cil-warning'" 
            :class="item.total_product_stock <= 0 ? 'text-danger' : 'text-warning'"
            class="mr-3"
            size="lg"
          />
          <div class="flex-grow-1 overflow-hidden">
            <div class="product-header mb-1">
              <div class="d-flex justify-content-between align-items-start">
                <span class="product-name mr-2">{{ item.label }}</span>
                <CBadge color="info" shape="pill" class="category-badge flex-shrink-0">{{ item.category || 'Stock' }}</CBadge>
              </div>
            </div>
            <div class="progress-container mt-2">
              <div class="d-flex justify-content-between align-items-center small mb-1">
                <span>Stock: <strong :class="item.total_product_stock <= 0 ? 'text-danger' : 'text-warning'">{{ item.total_product_stock }}</strong></span>
                <span>Mín: <strong>{{ item.stock_min }}</strong></span>
              </div>
              <!-- Simple horizontal line indicator -->
              <div class="stock-progress">
                <div 
                  class="progress-bar" 
                  :class="item.total_product_stock <= 0 ? 'bg-danger' : 'bg-warning'"
                  :style="{ width: Math.min((item.total_product_stock / item.stock_min) * 100, 100) + '%' }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </CDropdownItem>
    </div>

    <div v-else class="text-center py-4 text-muted">
      <CIcon name="cil-check-circle" size="xl" class="text-success mb-2 d-block mx-auto"/>
      No hay alertas pendientes
    </div>
    
    <CDropdownHeader tag="div" class="text-center py-1 border-top" color="light">
      <small>Actualizado: {{ lastUpdate }}</small>
    </CDropdownHeader>
  </CDropdown>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TheHeaderDropdownNotif',
  data () {
    return {
      items: [],
      lastUpdate: '',
      interval: null
    }
  },
  computed: {
    apiUrl() {
      return this.$store.getters.get__url;
    },
    campu() {
      return this.$store.getters.get_campu;
    },
    token() {
      return this.$store.getters.get__token;
    }
  },
  watch: {
    campu: {
      handler(newVal) {
        if (newVal) this.fetchLowStock();
      },
      immediate: true
    }
  },
  methods: {
    async fetchLowStock() {
      if (!this.campu) return;
      
      try {
        const response = await axios.get(`${this.apiUrl}/stock/byCampu/${this.campu.id}`, {
          headers: { Authorization: `Bearer ${this.token}` }
        });

        if (response.data && response.data.data && response.data.data.data) {
          this.items = response.data.data.data;
          this.lastUpdate = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
      } catch (error) {
        console.error("Error fetching low stock notifications:", error);
      }
    }
  },
  mounted() {
    this.interval = setInterval(this.fetchLowStock, 300000); // 5 min
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 10px;
}

.notification-scroll {
  max-height: 400px;
  overflow-y: auto;
  width: 400px;
}

.notification-item {
  width: 100%;
  cursor: pointer;
  background: #fff;
  white-space: normal; /* Permite saltos de línea */
}

.notification-item:hover {
  background: #f8f9fa;
}

.product-name {
  font-weight: 600;
  font-size: 0.88rem;
  color: #3c4b64;
  line-height: 1.25;
}

.category-badge {
  font-size: 0.65rem;
  padding: 0.2em 0.6em;
}

.stock-progress {
  height: 4px;
  background: #ebedef;
  border-radius: 2px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.6s ease;
}

/* Custom scroll style aligned with app */
.notification-scroll::-webkit-scrollbar {
  width: 5px;
}
.notification-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.notification-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}
</style>
